/**
 * Progressive enhancement for ANJA dialogs (size guides).
 * Links with [data-anja-dialog-open="<dialog id>"] work as plain links without JavaScript; with
 * JavaScript they open the native modal <dialog>, which provides focus containment, Escape to close
 * and an inert background. Focus is returned to the opener on close. Clicking the backdrop closes.
 * Uses one delegated listener, so sections re-rendered by the theme editor keep working.
 */
if (!window.anjaDialogsReady) {
  window.anjaDialogsReady = true;

  /** @type {WeakMap<HTMLDialogElement, HTMLElement>} */
  const openers = new WeakMap();

  document.addEventListener('click', (event) => {
    const target = /** @type {HTMLElement} */ (event.target);

    const opener = target.closest('[data-anja-dialog-open]');
    if (opener instanceof HTMLElement) {
      const dialog = document.getElementById(opener.dataset.anjaDialogOpen || '');
      if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
        event.preventDefault();
        openers.set(dialog, opener);
        dialog.showModal();
        dialog.querySelector('[data-anja-dialog-close]')?.focus();
      }
      return;
    }

    const closer = target.closest('[data-anja-dialog-close]');
    const dialog = /** @type {HTMLDialogElement | null} */ (target.closest('dialog.anja-dialog'));
    if (closer && dialog) {
      dialog.close();
      return;
    }

    // A click on the dialog element itself (not its content) is a click on the backdrop.
    if (target instanceof HTMLDialogElement && target.classList.contains('anja-dialog')) {
      const rect = target.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) target.close();
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement)) return;
      const opener = openers.get(dialog);
      if (opener?.isConnected) opener.focus();
    },
    true
  );
}
